import "../../App.css";
import LayerGroup from "ol/layer/Group";
import GeoJSON from "ol/format/GeoJSON";
import TileLayer from "ol/layer/Tile";
import { TileWMS } from "ol/source";
import mainWindow, { setLayersvalue } from "./../MainWindow";
import { getLayerName } from "../../TimeLine/MainTimeLineVisible";
import ImageLayer from "ol/layer/Image";
import ImageWMS from 'ol/source/ImageWMS';
import { map } from "../MainLayer";
import { weatherLayerGroup } from "../weather/weatherLayer";


export let floodLayerGroup = new LayerGroup({});

let receivedLayer: string = "";

type LayerMapType = Map<number, ImageLayer<ImageWMS>>;
let layerMap: LayerMapType = new Map();

export let floodMapGlofas: Map<string, LayerMapType> = new Map();
export let weatherMapICON: Map<string, LayerMapType> = new Map();

export function allFloodMap(weatherLayerName:string,layerMap:LayerMapType){
    floodMapGlofas.set(weatherLayerName,layerMap);
}

export function allWeatherMapICON(weatherLayerName:string,layerMap:LayerMapType){
  weatherMapICON.set(weatherLayerName,layerMap);
}

export default function SatelliteLayers (
    SatelliteLayer:  ImageLayer<ImageWMS>,
    isRemove: boolean,
    layerName: string
  ): void {
    if (!SatelliteLayer || !map) {
      return;
    }
    if (!layerName) {
      return;
    }
  
    if (isRemove === false) {
      weatherLayerGroup.getLayers().clear();
      // Add the layer if it's not already present
    //  SatelliteLayer.set("name", layerName);
        map.addLayer(SatelliteLayer);
        getLayerName(layerName, true);
        receivedLayer = layerName;
   
    } else {
      // Remove the layer if it exists
      const layersToRemove = map
        .getLayers()
        .getArray()
        .filter((layer) => layer.get("name") === layerName);
  
      layersToRemove.forEach((layer) => {
        map.removeLayer(layer);
     //   console.log(`Layer ${layerName} removed.`);
      });
  
      if (layersToRemove.length === 0) {
      //  console.log(`No layer found with the name ${layerName}.`);
      } else {
        getLayerName(layerName, false);
      }
    }
};